 $(document).ready(function() {
     function qtyUpdate() {
         // remove personalize qty from total qty of cart
         // Fetch cart data from Shopify's /cart.js endpoint
         fetch('/cart.js')
             .then(response => response.json())
             .then(cartData => {

                 // Initialize a variable to track the total quantity
                 let totalQty = 0;
                 // Loop through each item in the cart to calculate the total quantity
                 cartData.items.forEach(item => {
                     totalQty += item.quantity; // Add the quantity of each item to the total quantity
                 });

                 // Get the quantity of the specific variant with ID 46076304425172
                 const variantToRemoveQty = cartData.items.find(item => item.variant_id === 46076304425172);

                 // If the variant is found, subtract its quantity from the total
                 if (variantToRemoveQty) {
                     totalQty -= variantToRemoveQty.quantity;
                 }
                 $('cart-count.cart-count.cart-count--absolute.font-body-bolder').blur();
                 var qtyset = setInterval(function() {
                     $('cart-count.cart-count.cart-count--absolute.font-body-bolder').text(totalQty);
                 }, 300);
                 setTimeout(function() {
                     clearInterval(qtyset);
                 }, 3000);
             })
             .catch(error => console.error('Error fetching cart data:', error));
     }



     $(document).on('click', 'button.product-form__submit.btn.btn--secondary', function() {
         setTimeout(function() {
             qtyUpdate();
         }, 1000);

     });

     function updatePersonalizedCartPrices() {
         if (window.location.pathname === '/cart') {
             $('tr.cart-item.have_property').each(function() {
                 var $cartItem = $(this);

                 if ($cartItem.find('.personalize_product').length > 0) {

                     var originalPriceText = $cartItem.find('.custom_price').text().trim();
                     var originalPrice = parseInt(originalPriceText, 10) / 100;

                     var quantity = parseInt($cartItem.find('.custom_qty').val(), 10) || 0;
                     // alert(quantity);
                     if (window.shopifyData && window.shopifyData.product1) {
                         var additionalPricea = window.shopifyData.product1.price / 100;
                     }
                     //alert(additionalPricea);
                     //var additionalPricea = {{product1.price | money_without_currency }};
                     var additionalPricea = Number(originalPrice) + Number(additionalPricea);

                     $cartItem.find('.price.text-left.flex-col.flex.font-body-bolder').text('Rs. ' + additionalPricea);
                     var additionalPrice = additionalPricea * quantity;

                     var updatedPrice = additionalPricea * quantity;

                     $cartItem.find('.cart-item__total span.font-body-bolder').text('Rs. ' + updatedPrice);


                 }

             });
         }

     }

     $(document).on('click', '.have_property button.quantity__button[name="minus"]', function() {
         setTimeout(function() {
             $('tr.cart-item.hide_product button.quantity__button[name="minus"]').click();
           updatePersonalizedCartPrices();
             qtyUpdate();
         }, 1500);
         var priceset1 = setInterval(function() {
             updatePersonalizedCartPrices();
         }, 300);
         setTimeout(function() {
             clearInterval(priceset1);
         }, 3000);

     });
     $(document).on('click', '.have_property button.quantity__button[name="plus"]', function() {
         setTimeout(function() {
             $('tr.cart-item.hide_product button.quantity__button[name="plus"]').click();
             qtyUpdate();
         }, 1500);
         var priceset1 = setInterval(function() {
             updatePersonalizedCartPrices();
         }, 300);
         setTimeout(function() {
             clearInterval(priceset1);
         }, 3000);
     });
    $(document).on('click', 'tr.cart-item.simple_prod button.quantity__button[name="minus"]', function() {
         setTimeout(function() {
             qtyUpdate();
         }, 1500);
         var priceset1 = setInterval(function() {
             updatePersonalizedCartPrices();
         }, 300);
         setTimeout(function() {
             clearInterval(priceset1);
         }, 3000);

     });
     $(document).on('click', 'tr.cart-item.simple_prod button.quantity__button[name="plus"]', function() {
         setTimeout(function() {
             qtyUpdate();
         }, 1500);
         var priceset1 = setInterval(function() {
             updatePersonalizedCartPrices();
         }, 300);
         setTimeout(function() {
             clearInterval(priceset1);
         }, 3000);
     });
     setTimeout(function() {
         qtyUpdate();
         updatePersonalizedCartPrices();
     }, 1000);



     $(document).on('click', '.simple_prod [is="cart-remove-item"]', function() {

         setTimeout(function() {
             qtyUpdate();
         }, 1500);
         var priceset1 = setInterval(function() {
             updatePersonalizedCartPrices();
         }, 300);
         setTimeout(function() {
             clearInterval(priceset1);
         }, 3000);
     });




 });

 $(document).on('click', '.have_property [is="cart-remove-item"]', function() {
     var qt = $(this).parents('.cart-item__product').siblings('.cart-item__quantity').find('.custom_qty').val();

     qt = parseInt(qt, 10); // Ensure qt is an integer
     if (isNaN(qt) || qt <= 0) {
         //alert('Invalid quantity');
         return;
     }

     // Fetch the current cart data
     $.ajax({
         type: 'GET',
         url: '/cart.js',
         dataType: 'json',
         success: function(cartData) {
             // Find the product with the specific variant ID
             var targetProduct = cartData.items.find(function(item) {
                 return item.variant_id === 46076304425172;
             });

             if (targetProduct) {
                 var currentQty = targetProduct.quantity;
                 // alert(currentQty);
                 var newQty = currentQty - qt;
                 //alert(newQty);
                 if (newQty < 0) {
                     //alert('Quantity to subtract exceeds current quantity');
                     return;
                 }

                 // Update the product quantity in the cart
                 updateProductQuantity(targetProduct.key, newQty);
             } else {
                 // alert('Product with variant ID 46076304425172 not found in the cart.');
             }


         },
         error: function(error) {
             console.error('Error fetching cart data:', error);
         }
     });

     setTimeout(function() {
         // 
     }, 1500);

     setTimeout(function() {
         // Trigger remove button click for hide_product
         var removeButton = $('tr.hide_product [is="cart-remove-item"]');
         if (removeButton.length > 0) {
             //alert('Remove button found for hide_product.');
             location.reload(true);
         } else {
             //alert('No remove button found for hide_product.');
         }
         // qtyUpdate();
         // 
     }, 3000);

     // Function to update product quantity in the cart
     function updateProductQuantity(lineItemKey, quantity) {
         $.ajax({
             type: 'POST',
             url: '/cart/change.js',
             data: {
                 id: lineItemKey,
                 quantity: quantity
             },
             dataType: 'json',
             success: function(data) {
                 //  alert('Product quantity updated successfully.');
                 console.log('Updated Cart Data:', data);
                 setTimeout(function() {
                     //location.reload(true);
                 }, 1000);
             },
             error: function(error) {
                 // alert('Error updating product quantity:', error);
             }
         });
     }
 });




 $(document).ready(function() {
     //if (window.location.pathname === '/cart'){
     var totalQuantity = 0;

     $('.have_property').each(function() {
         var $cartItem = $(this);
         var quantity = parseInt($cartItem.find('.custom_qty').val(), 10) || 0;
         totalQuantity += quantity;
     });
     //alert(totalQuantity);
     var intervalId = setInterval(function() {
         if (totalQuantity > 0) {
             var variantIDs = 46076304425172;

             $.ajax({
                 type: 'GET',
                 url: '/cart.js',
                 dataType: 'json',
                 success: function(cartData) {
                     console.log('Cart Data:', cartData);
                     var existingProduct = cartData.items.find(function(item) {
                         return item.variant_id === variantIDs;
                     });

                     if (existingProduct) {
                         if (existingProduct.quantity === totalQuantity) {
                             //console.log('Product with the same quantity is already in the cart.');
                             clearInterval(intervalId);
                         } else {
                             //console.log('Product found with a different quantity, updating the cart...');
                             updateCartQuantity(existingProduct.id, totalQuantity);
                         }
                     } else {
                         //console.log('Product not in the cart, adding it now...');
                         addProductToCart(variantIDs, totalQuantity);
                     }
                 },
                 error: function(error) {
                     //console.error('Error fetching cart data:', error);
                 }
             });
         } else {
             //console.log('Total quantity is 0, no products added to cart.');
             clearInterval(intervalId);
         }

         function addProductToCart(variantID, quantity) {
             $.ajax({
                 type: 'POST',
                 url: '/cart/add.js',
                 data: {
                     quantity: quantity,
                     id: variantID
                 },
                 dataType: 'json',
                 success: function(data) {
                     //console.log('Product added to cart:', data);
                     location.reload(true);
                 },
                 error: function(error) {
                     //console.error('Error adding product to cart:', error);
                 }
             });
         }

         function updateCartQuantity(lineItemID, quantity) {
             $.ajax({
                 type: 'POST',
                 url: '/cart/update.js',
                 data: {
                     updates: {
                         [lineItemID]: quantity
                     }
                 },
                 dataType: 'json',
                 success: function(data) {
                     //console.log('Cart updated successfully:', data);
                     location.reload(true);
                 },
                 error: function(error) {
                     //console.error('Error updating cart:', error);
                 }
             });
         }

     }, 1000);



     //}
     if (window.location.pathname === '/cart') {
         $.ajax({
             type: 'GET',
             url: '/cart.js',
             dataType: 'json',
             success: function(cartData) {
                 console.log('Cart Data:', cartData);

                 // Filter items with specific properties
                 var productsWithProperties = cartData.items.filter(function(item) {
                     return item.properties && Object.keys(item.properties).length > 0; // Check if properties exist
                 });

                 if (productsWithProperties.length > 0) {
                     console.log('have');

                 } else {
                     console.log('No products with properties found.');

                     setTimeout(function() {

                         // Function to update product quantity in the cart
                         $.ajax({
                             type: 'POST',
                             url: '/cart/change.js',
                             data: {
                                 id: 46076304425172,
                                 quantity: 0
                             },
                             dataType: 'json',
                             success: function(data) {
                                 //alert('Product quantity updated successfully.');
                                 console.log('Updated Cart Data:', data);
                                 qtyUpdate();
                                 location.reload(true);

                             },
                             error: function(error) {
                                 console.error('Error updating product quantity:', error);
                             }
                         });

                         qtyUpdate();

                     }, 1000);
                 }



             },
             error: function(error) {
                 console.error('Error fetching cart data:', error);
             }
         });
     }
 });